module.exports = __webpack_public_path__ + "img/romain.e0dc0104.jpg";